import * as React from 'react';
import cx from 'classnames';
import ReactDOM from 'react-dom';

import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Dialog from 'components/Dialog';
import Glyph from 'components/Glyph';
import Image from 'components/Image';
import Icon from 'components/Icon';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import TextWithGlyph from 'components/TextWithGlyph';

import { MouseEventHandler } from 'types/typescript/eventHandlers';
import { FileGQL } from 'types/typescript/file';

import './styles/ImageFilePreviewModal.scss';

type Props = {
  file: FileGQL;
  className?: string;
  onRequestHide?: () => void;
};

class ImageFilePreviewModal extends React.Component<Props> {
  handleCloseButtonClick = () => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  handleModalClick: MouseEventHandler = (event) => {
    const { target } = event;

    const header = ReactDOM.findDOMNode(this.refs.header);
    if (header && header.contains(target as Node)) {
      return;
    }

    const image = ReactDOM.findDOMNode(this.refs.image);
    if (image && image.contains(target as Node)) {
      return;
    }

    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  render() {
    const { file } = this.props;
    const { url, fullFileUrl } = file;

    return (
      <Dialog
        {...this.props}
        box={false}
        hideCloseButton
        full
        theme="dark"
        className={cx('ImageFilePreviewModal', this.props.className)}
        onClick={this.handleModalClick}
      >
        <header ref="header" className="ImageFilePreviewModal-header">
          <MediaObject center figure="right" className="ImageFilePreviewModal-header-inner">
            <TextWithGlyph glyph="image" glyphSize="medium" truncate>
              {file.name}
            </TextWithGlyph>
            <Buttons reset="none">
              <Link
                href={fullFileUrl || url}
                target="_blank"
                color="whiteout"
                className="ImageFilePreviewModal-viewOriginalButton"
              >
                <Icon size="medium" name="external-link" />
                Open in a new tab
              </Link>
              <Button
                aria-label="Close"
                color="whiteout"
                level="icon"
                onClick={this.handleCloseButtonClick}
              >
                <Glyph name="close" solo />
              </Button>
            </Buttons>
          </MediaObject>
        </header>
        <div className="ImageFilePreviewModal-wrap">
          <div className="ImageFilePreviewModal-content">
            <Image ref="image" className="ImageFilePreviewModal-image" src={url} />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default ImageFilePreviewModal;
